import { useTheme } from '@mui/material/styles';
import React from 'react';

import { useTranslations } from '../../../hooks/use-translations';
import { LoginIcon } from '../../icons/LoginIcon';
import { RegisterIcon } from '../../icons/RegisterIcon';

import { MenuListItems } from './Sidebar';

export const useGuestMenu = (): MenuListItems => {
  const t = useTranslations('sidebar.guestMenu');
  const theme = useTheme();

  const color = theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[500];

  return [
    {
      title: t('Login'),
      target: '/account/login',
      icon: <LoginIcon color={color} />,
    },
    {
      title: t('Registration'),
      target: '/registration',
      icon: <RegisterIcon color={color} />,
    },
  ];
};
